(function ( $ ) {
  /** Radio button plugin
   *
   * when this HTML structure is provided.
   *
   *     <label class="rb-radio"><input type="radio" name="test-radio" ... /></label>
   *     <label class="rb-radio"><input type="radio" name="test-radio" ... /></label>
   *
   * Activating this plugin allows user to click on the label
   * to check the radio button.
   *
   * example:
   *
   *  $('.rb-radio').RBRadio();
   */
  $.fn.RBRadio = function () {
    return this.each(function() {
      $(this).on('click', function () {
        var r = $('input[type=radio]', $(this));
        if (r.length && ! r.is('checked') && !r.attr('disabled')) {
          r.prop('checked', true);
        }
      });
    });
  }

})(jQuery);
